var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 68,
    viewBox: "0 0 52 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_3531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.5H21.5M11.5 26H34M11.5 37H34M11.5 48H23.5M1 1.5H31.5V13.5H44.5V59H1V1.5Z",
    stroke: "#006EB2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 1.5L44.5 14",
    stroke: "#006EB2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1667 57.1667L50.1667 65.6667",
    stroke: "#006EB2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 51.1667C46.5 57.0923 41.877 61.8333 36.25 61.8333C30.623 61.8333 26 57.0923 26 51.1667C26 45.241 30.623 40.5 36.25 40.5C41.877 40.5 46.5 45.241 46.5 51.1667Z",
    fill: "#B0D8F0",
    stroke: "#006EB2",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_3531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 67,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverability);
export default __webpack_public_path__ + "static/media/discoverability.ae225f729f0b32dbf70198e9d3049786.svg";
export { ForwardRef as ReactComponent };